'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSeconds = exports.getMinutes = exports.getHours = exports.padZeroes = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var padZeroes = exports.padZeroes = function padZeroes(num) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  var paddedNum = num.toString();

  while (paddedNum.length < size) {
    paddedNum = '0' + paddedNum;
  }return paddedNum;
};
var getHours = exports.getHours = function getHours(msecs) {
  return padZeroes(Math.floor(msecs / (1000 * 60 * 60)) % 24);
};
var getMinutes = exports.getMinutes = function getMinutes(msecs) {
  return padZeroes(Math.floor(msecs / (1000 * 60)) % 60);
};
var getSeconds = exports.getSeconds = function getSeconds(msecs) {
  return padZeroes(Math.round(msecs / 1000) % 60);
};

var HoursMinsSeconds = function HoursMinsSeconds(_ref) {
  var duration = _ref.duration,
      running = _ref.running;
  return _react2.default.createElement(
    'div',
    { className: 'time ' + (running ? 'running' : 'stopped') },
    getHours(duration),
    ':',
    getMinutes(duration),
    ':',
    getSeconds(duration)
  );
};

HoursMinsSeconds.propTypes = {
  /**
   * Elapsed time in milliseconds
   */
  duration: _propTypes2.default.number,
  /**
   * Whether the timer is running or not
   */
  running: _propTypes2.default.bool
};

exports.default = HoursMinsSeconds;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/ElapsedTimer/HoursMinsSeconds.js
// module id = 490
// module chunks = 0